import { useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { base_url } from "../../config";
import axios from "axios";

function ExpirationCell({ code, value, onSaved }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value ?? "");

  const save = async () => {
    await axios.post(`${base_url}/api/admin/code_expiration`, {
      code,
      expires_at: draft || null,
    });
    setEditing(false);
    onSaved();
  };

  if (!editing) {
    return (
      <span
        className="cursor-pointer underline decoration-dotted"
        onClick={() => {
          setDraft(value ?? "");
          setEditing(true);
        }}
        title="Click to edit"
      >
        {value ?? "—"}
      </span>
    );
  }

  return (
    <span className="flex gap-1 items-center">
      <input
        type="date"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        className="border rounded px-1 py-0.5 text-sm"
      />
      <button
        className="text-teal-700 text-xs font-bold"
        onClick={save}
      >
        Save
      </button>
      <button
        className="text-gray-500 text-xs"
        onClick={() => setEditing(false)}
      >
        Cancel
      </button>
    </span>
  );
}

export default function App() {
  const [data, setData] = useState([]);
  const [reload, setReload] = useState(0);

  const triggerReload = () => setReload((r) => r + 1);

  const columns = useMemo(
    () => [
      {
        accessorKey: "code",
        header: "Code",
        muiTableHeadCellProps: { style: { color: "#444040" } },
        enableHiding: false,
      },
      {
        accessorKey: "status",
        header: "Status",
        muiTableHeadCellProps: { style: { color: "#444040" } },
        enableHiding: false,
      },
      {
        accessorKey: "email",
        header: "Email",
        muiTableHeadCellProps: { style: { color: "#444040" } },
        enableHiding: false,
      },
      {
        accessorKey: "name",
        header: "Name",
        muiTableHeadCellProps: { style: { color: "#444040" } },
        enableHiding: false,
      },
      {
        accessorKey: "expires_at",
        header: "Expires",
        muiTableHeadCellProps: { style: { color: "#444040" } },
        enableHiding: false,
        Cell: ({ row }) => (
          <ExpirationCell
            code={row.original.code}
            value={row.original.expires_at}
            onSaved={triggerReload}
          />
        ),
      },
    ],
    []
  );

  const createCode = async (type) => {
    await axios.post(`${base_url}/api/admin/codes`, { type });
    triggerReload();
  };

  useEffect(() => {
    const loadData = async () => {
      const comm = await axios.get(`${base_url}/api/admin/codes`);
      setData(comm.data);
    };

    loadData();
  }, [reload]);

  const table = useMaterialReactTable({
    columns,
    data,
    initialState: { density: "compact" },
    enableRowSelection: true,
    enableColumnOrdering: true,
    enableGlobalFilter: true,
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#e3f1ff",
      },
    },
  });

  return (
    <>
      <div className="flex mb-8 gap-4">
        <div className="button text-sm " onClick={() => createCode("vol")}>
          Create Volunteer Code
        </div>
        <div className="button text-sm" onClick={() => createCode("org")}>
          Create Oranizer Code
        </div>
        <div className="button text-sm" onClick={() => createCode("inv")}>
          Create Invitation Code
        </div>
      </div>
      <MaterialReactTable table={table} className="h-full" />
    </>
  );
}
